var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ExternalUsersEditor", {
    attrs: {
      group: _vm.group,
      groupSelector: _vm.groupSelector,
      availableSalutations: _vm.availableSalutations,
      hideDisabled: _vm.hideDisabled,
      hideMassSelection: _vm.hideMassSelection,
      allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers
    },
    scopedSlots: _vm._u(
      [
        {
          key: "externalUserButtonsBefore",
          fn: function({ groupUserExternal }) {
            return [
              _vm._t("externalUserButtonsBefore", null, {
                groupUserExternal: groupUserExternal
              })
            ]
          }
        },
        {
          key: "externalUserButtonsAfter",
          fn: function({ groupUserExternal }) {
            return [
              _vm._t("externalUserButtonsAfter", null, {
                groupUserExternal: groupUserExternal
              })
            ]
          }
        },
        {
          key: "selectedExternalUserButtonsBefore",
          fn: function({ groupUserExternals }) {
            return [
              _vm._t("selectedExternalUserButtonsBefore", null, {
                groupUserExternals: groupUserExternals
              })
            ]
          }
        },
        {
          key: "selectedExternalUserButtonsAfter",
          fn: function({ groupUserExternals }) {
            return [
              _vm._t("selectedExternalUserButtonsAfter", null, {
                groupUserExternals: groupUserExternals
              })
            ]
          }
        },
        {
          key: "externalUserSelectModalTabs",
          fn: function() {
            return [_vm._t("externalUserSelectModalTabs")]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }